import { render, staticRenderFns } from "./UNCCallback.vue?vue&type=template&id=b7f42478&scoped=true"
import script from "./UNCCallback.vue?vue&type=script&lang=ts"
export * from "./UNCCallback.vue?vue&type=script&lang=ts"
import style0 from "./UNCCallback.vue?vue&type=style&index=0&id=b7f42478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f42478",
  null
  
)

export default component.exports